export default __webpack_public_path__ + "media/color/crw-2f1368ed.svg";